import { useEffect, useState, useRef } from "react";
import PropTypes from 'prop-types';
import FAQ from "./FAQ";
import { useToken } from "../TokenContext.js";
import "./PromptRes.css";
import Logo from "./../assets/animation_v4.gif"
import userLogo from "./../assets/user_logo.png"
import { v4 as uuidv4 } from 'uuid';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const PromptRes = ({ currentSession, updateSession, updateSessionStarted, query, queryResponse, updateQuery, updateQueryResponse, updateEditMessage, username }) => {
  const [currentHistory, setCurrentHistory] =useState([]);
  const [sessionHistoryData, setSessionHistoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hover, setHover] = useState(null);
  // const [thumbsUpHover,setThumbsUpHover] = useState(null);
  // const [thumbsDownHover,setThumbsDownHover] = useState(null);

  const [copiedIndex, setCopiedIndex] =useState(null);
  const [thumbsUpIndex, setThumbsUpIndex] = useState(null);
  const [thumbsDownIndex, setThumbsDownIndex] = useState(null);
  // const [feedbacks, setFeedbacks] = useState({});

  PromptRes.propTypes = {
    currentSession: PropTypes.object.isRequired,
    updateSession: PropTypes.func.isRequired,
    query: PropTypes.string.isRequired,
    queryResponse: PropTypes.string.isRequired,
    updateQuery: PropTypes.func.isRequired,
    updateQueryResponse: PropTypes.func.isRequired,
    updateEditMessage: PropTypes.func.isRequired,
    username: PropTypes.string.isRequired,
    updateSessionStarted: PropTypes.func.isRequired,

  };
  useEffect(() => {
    updateSession(uuidv4());
    if (currentSession) {
      fetchSessionHistory(currentSession);
      setSessionHistoryData(currentHistory);
    }
  }, []);

  const token= useToken().token;
  const isGuest = useToken().isGuestToken;

  useEffect(() => {
    if(query){
    updateSessionStarted('true')}
    else{
      updateSessionStarted('false')
    }
  }, [sessionHistoryData,query]);
  const formatQueryResponse = (response) => {
    // Regular expression to find text enclosed by "**"
    const boldEnclosedRegex = /\*\*(.*?)\*\*/g;
  
    // Replace text between "**" with individual words prefixed with "**"
    return response.replace(/\n/g, ' \n ').replace(boldEnclosedRegex, (match, enclosedText) => {
      // Remove the enclosing "**" from the matched text
      const cleanText = enclosedText.trim(); // Clean the enclosed text
  
      // Split the enclosed text into words
      const words = cleanText.split(' ');
  
      // Prepend '**' before each word and join them back with spaces
      const formattedWords = words.map(word => `**${word}`).join(' ');
  
      // Return the modified text with "**" before each word
      return formattedWords;
    });
  };
  const [visibleWords, setVisibleWords] = useState(0);
  const words = typeof queryResponse === 'string' ? formatQueryResponse(queryResponse).split(' ') : [];
  // Split the queryResponse into lines

  useEffect(() => {
    if (words.length > 0) {
      // Reveal words one by one with a delay of 0.1 second per word
      const intervalId = setInterval(() => {
        if (visibleWords < words.length) {
          setVisibleWords(prev => prev + 1);
        } else {
          clearInterval(intervalId); // Stop when all words are shown
        }
      }, 10); // 0.1 second delay for each word

      return () => clearInterval(intervalId); // Cleanup interval on unmount
    }
  }, [visibleWords, words]);

  useEffect(() => {
    setVisibleWords(0); // Reset visibleWords to 0 when queryResponse changes
  }, [queryResponse]);

  const formatBoldText = (text) => {
    if (!text) {
      return ''; // Return an empty string if the text is undefined or null
    }
    return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  };
  
  const formatSpecialText = (text) => {
    // Replace "* " followed by space with a large dot "•"
    let formattedText = text.replace(/\*\s/g, '• ');
    if (formattedText.startsWith('**')) {
      formattedText = formattedText.slice(2); // Remove the first two characters ('**')
    }
    return formattedText;
  }; 
  

  useEffect(() => {
    //console.log("Current session:", currentSession, query);

    if (currentSession) {
      fetchSessionHistory(currentSession, query);
    }
  }, [currentSession, queryResponse]);

  const containerRef = useRef(null);

  useEffect(() => {
    //console.log("888888888888888888888888888888", username);
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [currentSession, sessionHistoryData, query, queryResponse]);
  

  const fetchSessionHistory = async (sessionId, query) => {
    //console.log("currentSession", currentSession);
    setSessionHistoryData(currentHistory);
    //console.log("query",query);
    setIsLoading(true);
    setError(null);

    try {
        const response = await fetch(`https://infia.enviseer.com/api/llm_backend/session/history`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ session_id: currentSession }),
        });

        if (!response.ok) {
            throw new Error('Failed to fetch session history');
        }

        const data = await response.json();
        setCurrentHistory(data);
        if(!query){
          setSessionHistoryData(data);
        }

        //console.log('Session history fetched and filtered');

    } catch (error) {
        console.error('Error:', error);
        setError('Error fetching session history.');
    } finally {
        setIsLoading(false);
    }
};


const handleThumbsUp = async (index, response) => {
  setThumbsUpIndex(index);
  setThumbsDownIndex(null); // Reset the thumbs-down state

  try {
    const feedbackResponse = await fetch('https://infia.enviseer.com/api/llm_backend/conversation_history/feedback', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        session_id: currentSession, // Replace with dynamic session ID if needed
        model_response: response, // Replace with dynamic response
        feedback: 1, // 1 for thumbs up
      }),
    });

    const data = await feedbackResponse.json();
    //console.log('Thumbs up feedback submitted:', data);

    updateQuery(null);
    updateQueryResponse(null);
    // Fetch updated session history after feedback is submitted
    await fetchSessionHistory();

  } catch (error) {
    console.error('Error submitting thumbs up feedback:', error);
  }

  // Reset the thumbs-up state after 2 seconds
  setTimeout(() => {
    setThumbsUpIndex(null);
  }, 1000); // 2000ms for 2 seconds
};

const handleThumbsDown = async (index, response) => {
  setThumbsDownIndex(index);
  setThumbsUpIndex(null); // Reset the thumbs-up state

  try {
    const feedbackResponse = await fetch('https://infia.enviseer.com/api/llm_backend/conversation_history/feedback', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        session_id: currentSession, // Replace with dynamic session ID if needed
        model_response: response, // Replace with dynamic response
        feedback: -1, // -1 for thumbs down
      }),
    });

    const data = await feedbackResponse.json();
    //console.log('Thumbs down feedback submitted:', data);

    updateQuery(null);
    updateQueryResponse(null);
    // Fetch updated session history after feedback is submitted
    await fetchSessionHistory();

  } catch (error) {
    console.error('Error submitting thumbs down feedback:', error);
  }

  // Reset the thumbs-down state after 2 seconds
  setTimeout(() => {
    setThumbsDownIndex(null);
  }, 1000); // 2000ms for 2 seconds
};


const copyToClipboard = (text,index) => {
  navigator.clipboard.writeText(text).then(() => {
    setCopiedIndex(index); // Set the copied index to the current message
    setTimeout(() => {
      setCopiedIndex(null); // Reset copied state after 2 seconds
    }, 1000);

  });
};

const handleEdit = (query)=>{
  //console.log("query_edit", query);
   updateEditMessage(query);
};
  const renderConversation = () => {
    const conversation = [];
     if(sessionHistoryData && sessionHistoryData.length>0){
    for (let i = 0; i < sessionHistoryData.length; i++) {
      const message = sessionHistoryData[i];
      if (message.sender === "user") {
        conversation.push(
          <div key={`user-${i}`} className="message-container">
             <div className="message-content">
                <div onClick={()=>handleEdit(message.text)}>
                   <i className="bi bi-pencil"></i>
                </div>
                <p>
                  <div className="query-text">{message.text}</div></p>
              </div>
              <img src={userLogo} width="80" height="80"/>
          </div>

        );

        while (sessionHistoryData[i + 1] && sessionHistoryData[i + 1].sender === "bot") {
          i++;
          conversation.push(
            <div key={`bot-${i}`} className="bot-message-container">
              <img className="bot-i" src={Logo} />
            <div className="bot-message-content">
              <div className="message-header">
                {/* <i className="bi bi-emoji-smile message-icon"></i> */}
                <p className="message-text" dangerouslySetInnerHTML={{ __html: formatBoldText(sessionHistoryData[i].text) }}/>
              </div>
              <div className="message-actions">
                <div className="thumbs-container">
                <button
                   className="thumbs-btn"
                   onClick={() => handleThumbsUp(i, sessionHistoryData[i].text)}
                  //  onMouseEnter={() => setThumbsUpHover(i)}
                  //  onMouseLeave={() => setThumbsUpHover(null)}
                   style={{
                      backgroundColor: thumbsUpIndex === i || hover === i ? 'white' : '', // White if clicked or hovered
                       border: thumbsUpIndex === i ? '2px solid green' : 'none' // Optional: add border when clicked
                   }}
                >
                  <i
                     className={thumbsUpIndex === i ||sessionHistoryData[i].feedback==1 ? 'bi-hand-thumbs-up-fill' : 'bi-hand-thumbs-up'}
                     style={{
                     color: thumbsUpIndex === i ? 'green' : sessionHistoryData[i].feedback===1 ? 'grey':'', // Green if thumbs-up is clicked, otherwise black
                     }}
                 ></i>
                </button>

                  <button
                    className="thumbs-btn"
                    onClick={() => handleThumbsDown(i, sessionHistoryData[i].text)}
                    // onMouseEnter={() => setThumbsDownHover(i)}
                    // onMouseLeave={() => setThumbsDownHover(null)}
                    style={{
                      backgroundColor: thumbsDownIndex === i || hover === i ? 'white' : '', // White if clicked or hovered
                      border: thumbsDownIndex === i ? '2px solid orange' : 'none' // Optional: add border when clicked
                    }} 
                  >
                  <i className={thumbsDownIndex === i|| sessionHistoryData[i].feedback === -1 ? 'bi-hand-thumbs-down-fill' : 'bi-hand-thumbs-down'} style={{color:thumbsDownIndex===i ? 'orange': sessionHistoryData[i].feedback=== -1? 'grey':''}}></i>
                  </button>
                </div>
                <button 
                  className="clipboard-btn" 
                  onClick={() => copyToClipboard(sessionHistoryData[i].text, i)} 
                  onMouseEnter={() => setHover(i)} 
                  onMouseLeave={() => setHover(null)}
                  style={{
                    backgroundColor: copiedIndex===i? 'white':'',
                    border: copiedIndex===i? '2px solid green':'none' 
                  }}
                  >
                    <i className={copiedIndex === i ? 'bi-check-circle-fill':'bi bi-clipboard'} style={{color:copiedIndex?'green':''}}></i>
                  <div className="copy-text" style={{ display: hover === i || copiedIndex === i ? 'flex' : 'none',color: copiedIndex === i ? 'green' : 'white'}}>{copiedIndex===i?<div>Copied</div>: <div>Copy</div>}</div>
                </button>
              </div>
            </div>
          </div>
          
          
          );
        }
      }
    }
  }
    if (query) {
      conversation.push(<div className="message-container">
        <div className="message-content" onClick={() => handleEdit(query)}>
          <i className="bi bi-pencil" ></i>
          <p className="query-text">{query}</p>
        </div>
        <img className="bot-i" src={userLogo} />
      </div>
      );
    }

    if (queryResponse) {
      conversation.push(
        <div className="bot-message-container">
          <img className="bot-i" src={Logo}/>
          {typeof queryResponse === 'string' ? (<div className="bot-message-content">
          <div className="message-header">
          {/* Check if queryResponse is a string or JSX and render accordingly */}
          
             <div className="message-text">
             {words.map((word, index) => {
               let wordClass = 'hidden-word'; // Default class for hidden words

               if (index < visibleWords - 10) {
                 wordClass = 'visible-word'; // Full visibility for older words
               } else if (index < visibleWords) {
                if(index>word.length-10){
                  wordClass = 'visible-word';
                }
                else{
                 wordClass = 'faded-word'; // Diminishing opacity for the next few words
                }
               }
               else if (visibleWords >= words.length) {
                wordClass = 'visible-word'; // Ensure all words are fully visible at the end
              }

              return (
                <span
                  key={index}
                  className={wordClass}
                  style={{ fontWeight: word.startsWith('**')? 'bold' : '400' }}
                >
                  {formatSpecialText(word + ' ')}
                </span>
               );
             })}
           </div>
        </div>
        <div className="message-actions">
                <div className="thumbs-container">
                <button
                   className="thumbs-btn"
                   onClick={() => handleThumbsUp('res', queryResponse)}
                  //  onMouseEnter={() => setThumbsUpHover('res')}
                  //  onMouseLeave={() => setThumbsUpHover(null)}
                   style={{
                      backgroundColor: thumbsUpIndex === 'res' || hover === 'res' ? 'white' : '', // White if clicked or hovered
                       border: thumbsUpIndex === 'res' ? '2px solid green' : 'none' // Optional: add border when clicked
                   }}
                >
                  <i
                     className={thumbsUpIndex === 'res' ? 'bi-hand-thumbs-up-fill' : 'bi-hand-thumbs-up'}
                     style={{
                     color: thumbsUpIndex === 'res' ? 'green' : '', // Green if thumbs-up is clicked, otherwise black
                     }}
                 ></i>
                </button>

                  <button
                    className="thumbs-btn"
                    onClick={() => handleThumbsDown('res', queryResponse)}
                    // onMouseEnter={() => setThumbsDownHover('res')}
                    // onMouseLeave={() => setThumbsDownHover(null)}
                    style={{
                      backgroundColor: thumbsDownIndex === 'res' || hover === 'res' ? 'white' : '', // White if clicked or hovered
                      border: thumbsDownIndex === 'res' ? '2px solid orange' : 'none' // Optional: add border when clicked
                    }} 
                  >
                  <i className={thumbsDownIndex === 'res' ? 'bi-hand-thumbs-down-fill' : 'bi-hand-thumbs-down'} 
                  style={{color:thumbsDownIndex==='res'? 'orange':''}}></i>
                  </button>
                </div>
                <button 
                  className="clipboard-btn" 
                  onClick={() => copyToClipboard(queryResponse, 'res')} 
                  onMouseEnter={() => setHover('res')} 
                  onMouseLeave={() => setHover(null)}
                  style={{
                    backgroundColor: copiedIndex==='res'? 'white':'',
                    border: copiedIndex==='res'? '2px solid green':'none' 
                  }}
                  >
                    <i className={copiedIndex === 'res' ? 'bi-check-circle-fill':'bi bi-clipboard'} style={{color:copiedIndex?'green':''}}></i>
                  <div className="copy-text" style={{ display: hover === 'res' || copiedIndex === 'res' ? 'flex' : 'none',color: copiedIndex === 'res' ? 'green' : 'white'}}>{copiedIndex==='res'?<div>Copied</div>: <div>Copy</div>}</div>
                </button>
              </div>
      </div>
      ) : (
        <div style={{width:'60%'}}>
        {queryResponse}
        </div>
      )}
    </div>
      );
    }

    return conversation;
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',justifySelf:'center',  width: '100%', borderRadius:'30px', paddingTop:'20px', height: '100%', paddingBottom:'0px' }}>
        <div ref={containerRef} style={{ display: 'flex', flexDirection: 'column', alignItems:'center', width: '100%',overflowY: 'scroll', scrollbarWidth: 'none' }}>
        { sessionHistoryData && sessionHistoryData.length > 0 ? (
           renderConversation()
          ) : query ? (
            renderConversation()
          ) : isLoading ? (
            <div style={{display:'flex', flexDirection:'row', width:'60%', height:'100px', justifySelf:'center', alignSelf:'center'}}>
                 <img src={Logo} width="80" height="80"/>
                 <p style={{alignSelf:'center'}}>Loading session history...</p>
              </div>
          ) :  error ? (
            <p>{error}</p>
          ) :<div className={isGuest?"faqGuest":"faq" }>
          <FAQ currentSession={currentSession} updateQuery={updateQuery} updateQueryResponse={updateQueryResponse} username={username}/>
        </div> 
          }
        </div>
    </div>
  );
};

export default PromptRes;
